import type { PartialDeep } from 'react-joyride'
import type { Options, Styles } from 'react-joyride'

export const tourOptions: Partial<Options> = {
  arrowColor: '#ffffff',
  overlayColor: 'rgba(0, 0, 0, 0.45)',
  primaryColor: '#1a472a',
  textColor: '#1a1a1a',
  zIndex: 10000,
  spotlightRadius: 12,
}

export const tourStyles: PartialDeep<Styles> = {
  tooltip: {
    borderRadius: '12px',
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
    fontSize: '14px',
    padding: '20px',
  },
  tooltipContainer: {
    textAlign: 'left' as const,
  },
  tooltipTitle: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '8px',
    color: '#1a472a',
  },
  tooltipContent: {
    fontSize: '14px',
    lineHeight: '1.5',
    color: '#4b5563',
    padding: '8px 0',
  },
  buttonPrimary: {
    backgroundColor: '#1a472a',
    borderRadius: '8px',
    color: '#ffffff',
    fontSize: '13px',
    fontWeight: 500,
    padding: '8px 16px',
  },
  buttonBack: {
    color: '#6b7280',
    fontSize: '13px',
    fontWeight: 500,
    marginRight: '8px',
  },
  buttonSkip: {
    color: '#9ca3af',
    fontSize: '13px',
  },
  buttonClose: {
    color: '#9ca3af',
  },
  beacon: {
    display: 'none',
  },
  beaconInner: {
    display: 'none',
  },
  beaconOuter: {
    display: 'none',
  },
}
